export default __webpack_public_path__ + "static/station-location-t-d22117947ede7f59bb36b32a0c6da86d.jpg";